var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.planPackage.name))]),_c('div',{staticClass:"subtitle-1 font-weight-medium"},[_vm._v("\n        "+_vm._s(_vm.$n(_vm.planPackage.price, 'currency'))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }